import { css } from 'styled-components'

export const visibleTaskControlsStyle = css`
  #taskControls {
    visibility: visible;
    opacity: 1;
  }
`
